import React, { useState } from "react";
import { authAPI } from "../services/api";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../i18n";

/**
 * A reminder, not a wall: an owner can use the trial with an unverified email,
 * but the platform cannot approve or convert the shop until it is confirmed,
 * so it keeps asking until they have. Resending is throttled by the server.
 */
const EmailVerificationBanner = () => {
  const { user } = useAuth();
  const { t, lang } = useI18n();
  const [hidden, setHidden] = useState(false);
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);

  if (!user || user.email_verified_at || hidden) return null;

  const resend = async () => {
    setBusy(true);
    try {
      await authAPI.resendVerification(lang);
      setMessage(t("auth.verify.resent"));
    } catch {
      setMessage(t("auth.verify.resendFailed"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      role="status"
      className="mb-4 flex flex-wrap items-center gap-x-3 gap-y-1 rounded-lg border border-sky-300 bg-sky-50 px-4 py-3 text-sm text-sky-900"
    >
      <span aria-hidden="true">✉️</span>
      <span className="flex-1 min-w-[12rem]">{message || t("auth.verify.bannerText")}</span>
      <button
        type="button"
        onClick={resend}
        disabled={busy}
        className="font-semibold underline disabled:opacity-50"
      >
        {busy ? t("auth.verify.resending") : t("auth.verify.resend")}
      </button>
      <button
        type="button"
        onClick={() => setHidden(true)}
        className="text-sky-700 hover:underline"
      >
        {t("auth.verify.dismiss")}
      </button>
    </div>
  );
};

export default EmailVerificationBanner;
